import { Box } from '@mui/material'
import { LinearGradientText } from './Layout'
import { ImgText } from '../../shared/utils/Heading'
import { Constants } from '../../shared/constants'
import { Link } from 'react-router-dom'

const SmLayout = ({children , title , text}) => {
    return (
        <Box padding={"20px"}>

            <Box mb={2} >
                <Link to={'/'}><img src={Constants.customImages.Logo} alt="logo" width={"100px"} height={"auto"} /></Link>
                <Box mb={4} sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                    <ImgText text={title} sx={{ textAlign: "center" }} />
                    <LinearGradientText text={text} />
                </Box>
                <Box>
                 {children}
                </Box>
            </Box>
        </Box>
    )
}

export default SmLayout